<template>
    <div id="sidebar" :class="{'open': active}">
    <el-menu router>
        <div class="logo-container">
            <img class="logo" src="../assets/logo.png" />
        </div>
            <el-menu-item index="/home">Home</el-menu-item>
            <el-menu-item index="/collectconsent">Collect Consent</el-menu-item>
       </el-menu>
   </div>
</template>

<script>
export default {
  name: 'Sidebar',
  props: ['active'],
};
</script>

<style lang="scss">
#sidebar {
    z-index: 5;
    width: $sidebar-size;
    border-right: 1px solid $grey;
    box-shadow: inset 0 0 0 0 $grey,0 2px 1px 0 rgba(47,61,73,.05);
    height: 100%;
    visibility: visible!important;
    overflow-x: hidden;
    will-change: transform;
    transition-duration: .2s;
    transition-timing-function: cubic-bezier(.4,0,.2,1);
    transition-property: transform;
    position: fixed;
    &.open {
        z-index: 111;
        transform: translate3d(0, 0, 0)!important;
    }
    @include respond-to('sm', 'xs') {
        z-index: 100;
        transform: translate3d(-#{$sidebar-size}, 0, 0)!important;
    }
    @include respond-to('lg') {
        transform: translate3d(0, 0, 0)!important;
    }

    .el-menu {
        height: 100%;
        display: flex;
        flex-direction: column;
    }

    .logo-container {
        text-align: center;
        width: 100%;
        height: 150px;
        background-color: #000;
        .logo {
            width: 215px;
            margin-top: 40px;
        }
    }
}
</style>
